// TODO remove after SW is migrated to React 18
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import React, { AnchorHTMLAttributes } from 'react';

export const emailLink = <T extends AnchorHTMLAttributes<HTMLAnchorElement>>(
  text: string,
  Component: React.ComponentType<T>
) => <Component {...({ href: `mailto:${text}` } as T)}>{text}</Component>;
